export const ACCOUNT_NAV_MENU: { [key: string]: string } = {
    generalInfos: 'general_infos',
    company: 'company',
    ordersHistory: 'orders_history',
    quotesHistory: 'quotes_history',
    invoicesHistory: 'invoices_history',
    orderDetail: 'order_detail',
    quoteDetail: 'quote_detail',
};

export const ORDERED_SIZES_ARRAY = [
    'UNICA',
    '3YXS',
    '2YXS',
    'YXS',
    'XXS',
    'XXS/XS',
    'XS',
    'XS/S',
    'S',
    'S/M',
    'M',
    'M/L',
    'L',
    'L/XL',
    'XL',
    'XL/XXL',
    'XXL',
    '2XL/3XL',
    '3XL',
    '4XL',
    '5XL',
    '3',
    '4',
    '5',
    '6',
    '6.5',
    '7',
    '7.5',
    '8',
    '8.5',
    '9',
    '9.5',
    '10',
    '10.5',
    '11',
    '32',
    '34',
    '35',
    '36',
    '37',
    '38',
    '39',
    '40',
    '41',
    '42',
    '43',
    '44',
    '45',
    '46',
    '47',
    '48',
    '49',
    'K26',
];

export const DATA_AREA_ID = '01';

export const SAMPLE_CSV_LINK =
    'https://cdn.shopify.com/s/files/1/0672/8574/5885/files/berardi_sample_csv.csv?v=1737107710';
